import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import DrawerToggle from '../drawer-toggle/drawer-toggle';
import Expandable, { trackingPropTypes } from '../expandable/expandable';

/**
 * ExpandingComponent takes a child component and truncates the component to a height in pixels, adding
 * a DrawerToggle below to toggle the component between truncated and un-truncated states.
 *
 * For full functionality, add the following CSS to the parent component/container, replacing pixel
 * values with the desired height/fade out point:
 *  .expanding_component__fade-out {
 *    max-height: 125px;
 *  }
 *  .expanding-component__fade-out:before {
 *    height: 125px;
 *    background: linear-gradient(transparent 70px, @white);
 *  }
 */
const ExpandingComponent = ({
  children,
  hideGradient,
  className,
  defaultOpen,
  ...otherProps
}) => (
  <Expandable
    trackingData={otherProps}
    isExpanded={defaultOpen}
    render={(toggleExpanded, isExpanded) => (
      <div className={classNames('expanding-component', className)}>
        <div
          className={classNames({
            'hide-gradient': hideGradient,
            'expanding-component__fade-out': !isExpanded,
          })}
        >
          {children}
        </div>
        <DrawerToggle
          onClick={toggleExpanded}
          isExpanded={isExpanded}
          openText="Close"
          closedText="See card details"
        />
      </div>
    )}
  />
);

ExpandingComponent.displayName = 'ExpandingComponent';

ExpandingComponent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isExpanded: PropTypes.bool,
  defaultOpen: PropTypes.bool,
  toggleExpanded: PropTypes.func,
  hideGradient: PropTypes.bool, // For CCFE-1516. Removes the to white gradient so the blue background looks solid.
  ...trackingPropTypes,
};

ExpandingComponent.defaultProps = {
  hideGradient: false,
};
export default ExpandingComponent;
